import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../pulse-loader/index';
import css from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import ButtonWrapper from './styled';
import { PRIMARY, BASIC, INLINE, DISABLED, CIRCLE, SUCCESS, WARNING } from './variants';

/**
 * The 3p school-roll button.
 *
 * @version 1.0.1
 * @author Voyager
 */

const Button = (props) => {
    const { className = '', icon = '', iconClassName = '', label = '',
        disabled, hidden, loading, loadingLabel, handleOnClick,
        buttonContainerDisabled = '', children } = props;

    const styleProps = {};

    [
        PRIMARY,
        BASIC,
        INLINE,
        DISABLED,
        CIRCLE,
        SUCCESS,
        WARNING
    ].forEach((style) => {
        if (props[style]) {
            styleProps[style] = true;
        }
    });

    const iconElement = icon === ''
        ? <div />
        : <div className={iconClassName}><SvgIcon icon={icon} /></div>;

    const buttonContainerDisabledStyle = buttonContainerDisabled === ''
        ? css.buttonContainerDisabled
        : buttonContainerDisabled;

    const buttonElement = loading
        ? <div className={buttonContainerDisabledStyle}>{iconElement}<span>{loadingLabel}</span><Loader size="5px" /></div>
        :
        (<ButtonWrapper
        /* eslint-disable */
            {...styleProps}
            className={className}
            hidden={hidden}
            onClick={disabled ? () => {} : handleOnClick}
            role="button"
            tabIndex={0}>
            <div>
                {iconElement}
                <span>{label}</span>
            </div>
            {children}
        </ButtonWrapper>);

    let finalView = buttonElement;

    if (hidden) {
        finalView = <div />;
    }

    return finalView;
};

Button.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    loadingLabel: PropTypes.string,
    buttonContainerDisabled: PropTypes.string,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    loading: PropTypes.bool,
    handleOnClick: PropTypes.func,
    primary: PropTypes.bool,
    basic: PropTypes.bool,
    inline: PropTypes.bool,
    cicle: PropTypes.bool
};
export default Button;



// WEBPACK FOOTER //
// ./app/components/button/index.js